import { WrapImsPacket } from '../../../../../store/utility';
import axiosInstance from '../../../../../services/axios/axios';

export const getDirectReports = async args => {
	try {
		const response = await axiosInstance.post(
			'/api/UserAccessReview/GetUserInfo/Staff',
			WrapImsPacket(args)
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching data from the server for direct reports: ' +
				ex
		);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server for direct reports',
		};
	}
};

export const getAppsByUser = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`api/UserAccessReview/GetUserApps/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching apps for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching apps for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};

export const getMobileDevicesByUser = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetUserMobileDevices/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching mobile devices for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching mobile devices for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};

export const getBadgesByUser = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetUserBadges/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching badge info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching badge info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};

export const getServiceAccountsByUser = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetUserServiceAccounts/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching badge info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching badge info for user with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};

export const getServiceAccountApps = async esoFiId => {
	try {
		const response = await axiosInstance.get(
			`/api/UserAccessReview/GetUserServiceAccountApps/${esoFiId}`
		);
		return response;
	} catch (ex) {
		console.error(
			'error occurred fetching apps for service account with eso.FiId = ' +
				esoFiId +
				': ' +
				ex
		);
		return {
			data: [],
			error:
				'error occurred fetching apps for service account with eso.FiId = ' +
				esoFiId +
				': ' +
				ex,
		};
	}
};

export const submitValidations = async (staffMembers, currentUser) => {
	try {
		let request = {
			loggedInUser: currentUser,
			targets: staffMembers,
			newRenewalDate: null,
		};

		let packet = WrapImsPacket(request);
		const response = await axiosInstance.post(
			`api/UserAccessReview/v2/Validation`,
			packet
		);

		if (response.data.payload !== true) {
			throw new Error('server error');
		}

		return response;
	} catch (ex) {
		return {
			data: [],
			error: 'error occurred submitting validation requests',
		};
	}
};
